import { useMemo } from 'react';
import { fetchNodeExamples } from '../../api';
import { buildNodeParams } from './nodeFilterUtils';
import useNodeRequest from './useNodeRequest';

/**
 * Текстовые выходы узла: краткое содержание, цитаты, подтверждения.
 *
 * По умолчанию такие выходы скрыты с дашборда (`chart.hidden`), потому что списком они
 * полезны не всегда. Но раньше они выбрасывались из сетки безусловно, и у автора пакета
 * не было способа их показать — этот рендерер и есть такой способ.
 */
const QUOTES_LIMIT = 12;

const formatDate = (value) => {
  if (!value) {
    return '';
  }

  const date = new Date(value);
  return Number.isNaN(date.getTime())
    ? ''
    : date.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: '2-digit' });
};

const NodeQuoteList = ({ chart, dateRange, callType, nodeFilter, packVersion, scope }) => {
  const params = useMemo(
    () => ({ ...buildNodeParams({ chart, dateRange, callType, nodeFilter, packVersion, scope }), limit: QUOTES_LIMIT }),
    [chart, dateRange, callType, nodeFilter, packVersion, scope]
  );

  const { data, error } = useNodeRequest({
    fetcher: fetchNodeExamples,
    params,
    errorText: 'Не удалось загрузить цитаты.',
    enabled: Boolean(params.date_from && params.date_to)
  });

  const rows = useMemo(
    () =>
      (Array.isArray(data) ? data : [])
        .map((row) => ({ ...row, text: row.valueText || row.evidence }))
        .filter((row) => row.text),
    [data]
  );

  if (error) {
    return <div className="rounded-md border border-red-200 bg-red-50 p-3 text-sm text-red-800">{error}</div>;
  }

  if (rows.length === 0) {
    return <p className="text-sm text-muted-foreground">Нет данных за выбранный период.</p>;
  }

  return (
    <ul className="space-y-2">
      {rows.map((row) => (
        <li key={row.callId} className="rounded-md border bg-muted/20 p-3">
          <p className="text-sm">{row.text}</p>
          <p className="mt-1 text-xs text-muted-foreground">
            {[row.employeeName, formatDate(row.callStartedAt)].filter(Boolean).join(' · ')}
          </p>
        </li>
      ))}
    </ul>
  );
};

export default NodeQuoteList;
